import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { CoreModule } from "./app/core/core.module";


platformBrowserDynamic()
  .bootstrapModule(CoreModule)
  /* eslint-disable-next-line @unicorn/prefer-top-level-await, no-console, @tseslint/dot-notation */
  .catch(console.error);
